import React from 'react';
import { motion } from 'framer-motion';

const styles = `
  @import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700;800;900&display=swap');

  .pst-page * { box-sizing: border-box; margin: 0; padding: 0; }
  .pst-page { font-family: 'Inter', sans-serif; color: #0f172a; background: #ffffff; width: 100%; }

  /* ─── Hero ─────────────────────────────────────────────────── */
  .pst-hero { position: relative; padding: 100px 24px 120px; overflow: hidden; background: #fff; }
  .pst-hero-blob1 { position: absolute; top: -10%; right: -5%; width: 520px; height: 520px; border-radius: 50%; background: radial-gradient(circle, rgba(14,165,233,0.14), rgba(2,132,199,0.06)); filter: blur(80px); pointer-events: none; }
  .pst-hero-blob2 { position: absolute; bottom: -12%; left: -8%; width: 560px; height: 560px; border-radius: 50%; background: radial-gradient(circle, rgba(16,185,129,0.1), rgba(5,150,105,0.05)); filter: blur(90px); pointer-events: none; }
  .pst-hero-inner { max-width: 1200px; margin: 0 auto; display: grid; grid-template-columns: 1fr 1fr; gap: 72px; align-items: center; position: relative; z-index: 1; }
  @media (max-width: 900px) { .pst-hero-inner { grid-template-columns: 1fr; } .pst-hero-visual { display: none; } }
  .pst-back-btn { display: inline-flex; align-items: center; gap: 6px; padding: 7px 16px; border-radius: 999px; border: 1px solid #e2e8f0; background: #fff; color: #475569; font-size: 12px; font-weight: 600; cursor: pointer; transition: all 0.18s ease; margin-bottom: 24px; }
  .pst-back-btn:hover { background: #f0f9ff; border-color: #bae6fd; color: #0284c7; }
  .pst-hero-badge { display: inline-flex; align-items: center; gap: 8px; padding: 8px 16px; border-radius: 999px; background: #f0f9ff; border: 1px solid #bae6fd; font-size: 13px; font-weight: 500; color: #0c4a6e; margin-bottom: 28px; }
  .pst-badge-dot { width: 7px; height: 7px; border-radius: 50%; background: #0ea5e9; display: inline-block; animation: pst-pulse 2s infinite; }
  @keyframes pst-pulse { 0%,100%{opacity:1;box-shadow:0 0 0 0 rgba(14,165,233,0.4);}50%{opacity:.85;box-shadow:0 0 0 6px rgba(14,165,233,0);} }
  .pst-hero h1 { font-size: clamp(1.8rem, 3.75vw, 3rem); font-weight: 900; line-height: 1.1; letter-spacing: -0.03em; color: #0f172a; margin-bottom: 24px; }
  .pst-gradient-text { background: linear-gradient(135deg, #0284c7, #10b981); -webkit-background-clip: text; -webkit-text-fill-color: transparent; background-clip: text; }
  .pst-hero p { font-size: 1.15rem; color: #475569; line-height: 1.75; margin-bottom: 40px; font-weight: 300; max-width: 520px; }
  .pst-btn-group { display: flex; gap: 14px; flex-wrap: wrap; }
  .pst-btn-primary { padding: 14px 28px; background: #0f172a; color: #fff; border: none; border-radius: 12px; font-size: 15px; font-weight: 600; cursor: pointer; display: inline-flex; align-items: center; gap: 8px; transition: all 0.2s; }
  .pst-btn-primary:hover { background: #0284c7; box-shadow: 0 8px 24px rgba(2,132,199,0.35); transform: translateY(-1px); }
  .pst-btn-secondary { padding: 14px 28px; background: #fff; color: #334155; border: 1.5px solid #e2e8f0; border-radius: 12px; font-size: 15px; font-weight: 600; cursor: pointer; transition: all 0.2s; }
  .pst-btn-secondary:hover { border-color: #bae6fd; background: #f0f9ff; color: #0c4a6e; }

  /* Hero Visual */
  .pst-hero-visual { background: #fff; border-radius: 28px; border: 1px solid #e2e8f0; padding: 32px; box-shadow: 0 24px 64px rgba(2,132,199,0.07); }
  .pst-vis-header { display: flex; justify-content: space-between; align-items: center; margin-bottom: 24px; padding-bottom: 18px; border-bottom: 1px solid #f1f5f9; }
  .pst-vis-title p:first-child { font-size: 11px; color: #94a3b8; font-weight: 600; text-transform: uppercase; letter-spacing: 0.08em; margin-bottom: 3px; }
  .pst-vis-title p:last-child { font-size: 17px; font-weight: 800; color: #0f172a; }
  .pst-vis-icon { width: 46px; height: 46px; background: linear-gradient(135deg, #0284c7, #0ea5e9); border-radius: 13px; display: flex; align-items: center; justify-content: center; font-size: 20px; }
  .pst-filing-item { display: flex; align-items: center; gap: 12px; padding: 12px 14px; border-radius: 11px; margin-bottom: 8px; border: 1px solid; }
  .pst-filing-item.done { background: #f0f9ff; border-color: #bae6fd; }
  .pst-filing-item.alert { background: #fff7ed; border-color: #fed7aa; }
  .pst-filing-item.upcoming { background: #f8fafc; border-color: #f1f5f9; }
  .pst-filing-icon { font-size: 16px; flex-shrink: 0; }
  .pst-filing-content { flex: 1; }
  .pst-filing-title { font-size: 13px; font-weight: 700; color: #334155; }
  .pst-filing-sub { font-size: 11px; color: #94a3b8; margin-top: 1px; }
  .pst-filing-badge { font-size: 11px; font-weight: 700; padding: 2px 8px; border-radius: 999px; }
  .pst-filing-badge.done { background: #dbeafe; color: #1d4ed8; }
  .pst-filing-badge.alert { background: #fef3c7; color: #92400e; }
  .pst-filing-badge.upcoming { background: #f1f5f9; color: #64748b; }
  .pst-vis-summary { margin-top: 16px; padding: 14px 16px; background: #0f172a; border-radius: 12px; display: flex; align-items: center; gap: 10px; }
  .pst-vis-summary-dot { width: 8px; height: 8px; min-width: 8px; border-radius: 50%; background: #38bdf8; box-shadow: 0 0 8px rgba(56,189,248,0.8); display: block; }
  .pst-vis-summary-text { font-size: 13px; color: #e2e8f0; font-weight: 500; }

  /* ─── Stats ─────────────────────────────────────────────────── */
  .pst-stats { border-top: 1px solid #f1f5f9; border-bottom: 1px solid #f1f5f9; }
  .pst-stats-grid { display: grid; grid-template-columns: repeat(4,1fr); max-width: 1200px; margin: 0 auto; }
  @media (max-width: 768px) { .pst-stats-grid { grid-template-columns: repeat(2,1fr); } }
  .pst-stat { padding: 36px 24px; text-align: center; border-right: 1px solid #f1f5f9; }
  .pst-stat:last-child { border-right: none; }
  @media (max-width: 768px) { .pst-stat:nth-child(2n){ border-right:none; } .pst-stat{ border-bottom:1px solid #f1f5f9; } }
  .pst-stat-num { font-size: 2.2rem; font-weight: 900; letter-spacing: -0.03em; line-height: 1; margin-bottom: 8px; color: #0284c7; }
  .pst-stat-num.dark { color: #0f172a; }
  .pst-stat-label { font-size: 0.82rem; color: #64748b; font-weight: 500; }

  /* ─── Section Base ───────────────────────────────────────────── */
  .pst-section { padding: 96px 24px; }
  .pst-container { max-width: 1200px; margin: 0 auto; }
  .pst-section-header { text-align: center; max-width: 700px; margin: 0 auto 64px; }
  .pst-section-header h2 { font-size: clamp(1.8rem, 3.5vw, 2.8rem); font-weight: 800; color: #0f172a; letter-spacing: -0.02em; margin-bottom: 16px; line-height: 1.2; }
  .pst-section-header p { font-size: 1.05rem; color: #64748b; line-height: 1.75; }
  .pst-label { display: inline-block; font-size: 12px; font-weight: 700; letter-spacing: 0.1em; text-transform: uppercase; color: #0284c7; margin-bottom: 12px; }

  /* ─── Split Services ─────────────────────────────────────────── */
  .pst-split { background: #f8fafc; }
  .pst-split-inner { display: grid; grid-template-columns: 1fr 1fr; gap: 32px; }
  @media (max-width: 900px) { .pst-split-inner { grid-template-columns: 1fr; } }
  .pst-half { background: #fff; border-radius: 24px; border: 1px solid #e2e8f0; padding: 40px; }
  .pst-half-icon { font-size: 36px; margin-bottom: 20px; display: block; }
  .pst-half h2 { font-size: 1.6rem; font-weight: 800; color: #0f172a; margin-bottom: 14px; }
  .pst-half > p { font-size: 0.98rem; color: #64748b; line-height: 1.75; margin-bottom: 28px; }
  .pst-service-list { display: flex; flex-direction: column; gap: 12px; }
  .pst-service-row { display: flex; gap: 12px; align-items: flex-start; }
  .pst-service-dot { width: 20px; height: 20px; border-radius: 50%; display: flex; align-items: center; justify-content: center; font-size: 10px; font-weight: 700; flex-shrink: 0; margin-top: 1px; }
  .pst-service-dot.blue { background: #dbeafe; color: #1d4ed8; }
  .pst-service-dot.green { background: #d1fae5; color: #059669; }
  .pst-service-row-text { font-size: 14px; color: #374151; line-height: 1.55; font-weight: 500; }

  /* ─── Filing Calendar ────────────────────────────────────────── */
  .pst-calendar { background: #fff; }
  .pst-cal-inner { background: #0f172a; border-radius: 32px; padding: 80px 64px; position: relative; overflow: hidden; }
  @media (max-width: 900px) { .pst-cal-inner { padding: 48px 32px; } }
  .pst-cal-glow1 { position: absolute; top: 0; right: 0; width: 400px; height: 400px; background: radial-gradient(circle, rgba(14,165,233,0.2), transparent 70%); pointer-events: none; }
  .pst-cal-glow2 { position: absolute; bottom: 0; left: 0; width: 350px; height: 350px; background: radial-gradient(circle, rgba(16,185,129,0.12), transparent 70%); pointer-events: none; }
  .pst-cal-header { text-align: center; margin-bottom: 56px; position: relative; z-index: 1; }
  .pst-cal-header .pst-label { color: #7dd3fc; }
  .pst-cal-header h2 { font-size: clamp(1.8rem, 3.5vw, 2.8rem); font-weight: 800; color: #fff; letter-spacing: -0.02em; }
  .pst-cal-header p { font-size: 1.05rem; color: #94a3b8; margin-top: 16px; line-height: 1.7; }
  .pst-filings-grid { display: grid; grid-template-columns: repeat(3,1fr); gap: 20px; position: relative; z-index: 1; }
  @media (max-width: 900px) { .pst-filings-grid { grid-template-columns: repeat(2,1fr); } }
  @media (max-width: 500px) { .pst-filings-grid { grid-template-columns: 1fr; } }
  .pst-filing-card { background: rgba(30,41,59,0.5); border: 1px solid rgba(71,85,105,0.4); border-radius: 20px; padding: 26px; transition: border-color 0.3s; }
  .pst-filing-card:hover { border-color: rgba(14,165,233,0.5); }
  .pst-fc-form { font-size: 11px; font-weight: 700; color: #7dd3fc; text-transform: uppercase; letter-spacing: 0.1em; margin-bottom: 8px; }
  .pst-fc-title { font-size: 1.05rem; font-weight: 700; color: #f1f5f9; margin-bottom: 8px; }
  .pst-fc-freq { font-size: 12px; color: #38bdf8; font-weight: 600; margin-bottom: 10px; }
  .pst-fc-desc { font-size: 12px; color: #94a3b8; line-height: 1.6; }

  /* ─── Nexus ───────────────────────────────────────────────────── */
  .pst-nexus { background: #f8fafc; }
  .pst-nexus-inner { display: grid; grid-template-columns: 1fr 1fr; gap: 80px; align-items: center; }
  @media (max-width: 900px) { .pst-nexus-inner { grid-template-columns: 1fr; gap: 48px; } }
  .pst-nexus-left h2 { font-size: clamp(1.8rem, 3.5vw, 2.6rem); font-weight: 800; color: #0f172a; letter-spacing: -0.02em; margin-bottom: 16px; line-height: 1.2; }
  .pst-nexus-left > p { font-size: 1.05rem; color: #64748b; line-height: 1.75; margin-bottom: 36px; }
  .pst-nexus-triggers { display: flex; flex-direction: column; gap: 12px; }
  .pst-nexus-trigger { display: flex; align-items: flex-start; gap: 14px; padding: 16px 18px; background: #fff; border: 1px solid #e2e8f0; border-radius: 12px; transition: all 0.2s; }
  .pst-nexus-trigger:hover { border-color: #bae6fd; background: #f0f9ff; }
  .pst-nexus-icon { font-size: 20px; flex-shrink: 0; margin-top: 1px; }
  .pst-nexus-text h4 { font-size: 14px; font-weight: 700; color: #1e293b; margin-bottom: 3px; }
  .pst-nexus-text p { font-size: 13px; color: #64748b; line-height: 1.5; }
  .pst-nexus-visual { background: #fff; border: 1px solid #e2e8f0; border-radius: 24px; padding: 36px; box-shadow: 0 20px 60px rgba(0,0,0,0.05); }
  .pst-nv-title { font-size: 15px; font-weight: 800; color: #0f172a; margin-bottom: 24px; }
  .pst-state-grid { display: grid; grid-template-columns: repeat(3,1fr); gap: 8px; margin-bottom: 24px; }
  .pst-state-chip { padding: 8px 10px; border-radius: 10px; text-align: center; }
  .pst-state-chip.active { background: #dbeafe; border: 1px solid #bae6fd; }
  .pst-state-chip.watch { background: #fefce8; border: 1px solid #fef08a; }
  .pst-state-chip.clear { background: #f8fafc; border: 1px solid #f1f5f9; }
  .pst-state-abbr { font-size: 12px; font-weight: 800; }
  .pst-state-abbr.active { color: #1d4ed8; }
  .pst-state-abbr.watch { color: #ca8a04; }
  .pst-state-abbr.clear { color: #94a3b8; }
  .pst-state-status { font-size: 10px; font-weight: 600; margin-top: 2px; }
  .pst-state-status.active { color: #2563eb; }
  .pst-state-status.watch { color: #a16207; }
  .pst-state-status.clear { color: #94a3b8; }
  .pst-nv-legend { display: flex; gap: 16px; flex-wrap: wrap; }
  .pst-nv-legend-item { display: flex; align-items: center; gap: 6px; font-size: 12px; color: #64748b; font-weight: 500; }
  .pst-nv-dot { width: 10px; height: 10px; border-radius: 50%; }

  /* ─── Penalties ───────────────────────────────────────────────── */
  .pst-penalties { background: #fff; }
  .pst-pen-grid { display: grid; grid-template-columns: repeat(3,1fr); gap: 20px; }
  @media (max-width: 900px) { .pst-pen-grid { grid-template-columns: repeat(2,1fr); } }
  @media (max-width: 600px) { .pst-pen-grid { grid-template-columns: 1fr; } }
  .pst-pen-card { background: #f8fafc; border: 1px solid #f1f5f9; border-radius: 20px; padding: 28px; transition: all 0.3s; }
  .pst-pen-card:hover { background: #fff; border-color: #bae6fd; box-shadow: 0 12px 40px rgba(0,0,0,0.07); transform: translateY(-2px); }
  .pst-pen-amount { font-size: 1.8rem; font-weight: 900; color: #ef4444; letter-spacing: -0.02em; margin-bottom: 6px; }
  .pst-pen-name { font-size: 0.98rem; font-weight: 700; color: #1e293b; margin-bottom: 10px; }
  .pst-pen-desc { font-size: 0.88rem; color: #64748b; line-height: 1.65; }

  /* ─── FAQ ───────────────────────────────────────────────────── */
  .pst-faq { background: #f8fafc; }
  .pst-faq-grid { display: grid; grid-template-columns: repeat(2,1fr); gap: 18px; }
  @media (max-width: 768px) { .pst-faq-grid { grid-template-columns: 1fr; } }
  .pst-faq-item { background: #fff; border: 1px solid #e2e8f0; border-radius: 16px; padding: 26px; transition: all 0.2s; }
  .pst-faq-item:hover { border-color: #bae6fd; box-shadow: 0 4px 16px rgba(0,0,0,0.05); }
  .pst-faq-q { font-size: 0.98rem; font-weight: 700; color: #0f172a; margin-bottom: 10px; display: flex; gap: 10px; align-items: flex-start; }
  .pst-faq-q-icon { width: 22px; height: 22px; border-radius: 6px; background: #f0f9ff; display: flex; align-items: center; justify-content: center; font-size: 12px; color: #0284c7; flex-shrink: 0; margin-top: 1px; }
  .pst-faq-a { font-size: 0.9rem; color: #64748b; line-height: 1.7; }

  /* ─── CTA ────────────────────────────────────────────────────── */
  .pst-cta { background: #fff; border-top: 1px solid #f1f5f9; padding: 96px 24px; }
  .pst-cta-inner { background: #0f172a; border-radius: 32px; padding: 80px 48px; text-align: center; position: relative; overflow: hidden; max-width: 1000px; margin: 0 auto; }
  @media (max-width: 600px) { .pst-cta-inner { padding: 48px 24px; } }
  .pst-cta-glow1 { position: absolute; top: 0; right: 0; width: 360px; height: 360px; background: radial-gradient(circle, rgba(14,165,233,0.22), transparent 70%); pointer-events: none; }
  .pst-cta-glow2 { position: absolute; bottom: 0; left: 0; width: 300px; height: 300px; background: radial-gradient(circle, rgba(16,185,129,0.15), transparent 70%); pointer-events: none; }
  .pst-cta-inner h2 { font-size: clamp(2rem,4vw,3rem); font-weight: 900; color: #fff; letter-spacing: -0.03em; line-height: 1.15; margin-bottom: 20px; position: relative; z-index: 1; }
  .pst-cta-inner p { font-size: 1.1rem; color: #94a3b8; font-weight: 300; max-width: 540px; margin: 0 auto 40px; line-height: 1.75; position: relative; z-index: 1; }
  .pst-cta-btns { display: flex; gap: 16px; justify-content: center; flex-wrap: wrap; position: relative; z-index: 1; margin-bottom: 36px; }
  .pst-cta-primary { padding: 16px 32px; background: linear-gradient(135deg, #0284c7, #0ea5e9); color: #fff; border: none; border-radius: 12px; font-size: 16px; font-weight: 700; cursor: pointer; transition: all 0.2s; box-shadow: 0 4px 20px rgba(2,132,199,0.4); }
  .pst-cta-primary:hover { transform: translateY(-1px); box-shadow: 0 8px 28px rgba(2,132,199,0.5); }
  .pst-cta-secondary { padding: 16px 32px; background: rgba(255,255,255,0.06); color: #fff; border: 1px solid rgba(255,255,255,0.15); border-radius: 12px; font-size: 16px; font-weight: 700; cursor: pointer; transition: all 0.2s; }
  .pst-cta-secondary:hover { background: rgba(255,255,255,0.1); }
  .pst-cta-badges { display: flex; gap: 24px; justify-content: center; flex-wrap: wrap; position: relative; z-index: 1; }
  .pst-cta-badge { display: flex; align-items: center; gap: 6px; font-size: 13px; color: #94a3b8; }
  .pst-cta-badge-check { color: #7dd3fc; }
`;

const fadeIn = { initial:{opacity:0,y:28}, whileInView:{opacity:1,y:0}, viewport:{once:true,margin:'-50px'}, transition:{duration:0.55} };
const stagger = (i:number) => ({ initial:{opacity:0,y:24}, whileInView:{opacity:1,y:0}, viewport:{once:true,margin:'-40px'}, transition:{duration:0.5,delay:i*0.1} });

const payrollServices = [
  'Federal 941 quarterly payroll tax deposits & returns','State withholding registration and ongoing filings','Annual W-2 and W-3 preparation and e-filing','1099-NEC filing for contractors & freelancers','New hire reporting to state agencies','FUTA (940) annual federal unemployment return','Officer reasonable compensation analysis (S-Corps)','Payroll tax deposit schedule setup & reminders',
];

const salesTaxServices = [
  'Multi-state nexus analysis (economic & physical presence)','Sales tax registration in new states','Monthly, quarterly, and annual sales tax returns','Taxability analysis by product/service type','Marketplace facilitator compliance (Amazon, Etsy, etc.)','Voluntary disclosure agreements (VDA) for back taxes','Audit defense for state sales tax examinations','Exemption certificate management',
];

const filingCards = [
  { form:'Form 941', title:'Quarterly Payroll Return', freq:'Quarterly', desc:'Reports wages paid, taxes withheld, and employer FICA contributions. Due the last day of the month following each quarter.' },
  { form:'Form 940', title:'Annual FUTA Return', freq:'Annual', desc:'Reports federal unemployment tax (FUTA). Due January 31 each year, with deposits required quarterly if liability exceeds $500.' },
  { form:'W-2 / W-3', title:'Annual Wage & Tax Statements', freq:'Annual (Jan 31)', desc:'Provided to employees and filed with the SSA by January 31. Late filing penalties start at $60 per form.' },
  { form:'1099-NEC', title:'Contractor Payments', freq:'Annual (Jan 31)', desc:'Required for any contractor or unincorporated business paid $600+ during the year. Also filed with the IRS by January 31.' },
  { form:'State Sales Tax', title:'State Sales & Use Tax Return', freq:'Monthly / Quarterly', desc:'Filing frequency and due dates vary by state and revenue volume. We track and file all required state returns.' },
  { form:'Form ST-3 / ST-4', title:'Sales Tax Exemption Certificates', freq:'Ongoing', desc:'Proper collection and management of resale and exemption certificates is required documentation during a sales tax audit.' },
];

const nexusTriggers = [
  { icon:'🏢', title:'Physical Location', desc:'An office, warehouse, or store in a state creates physical nexus — the clearest form of sales tax obligation.' },
  { icon:'👥', title:'Remote Employees or Contractors', desc:'A remote employee working in another state often creates both income tax nexus and potentially sales tax nexus in that state.' },
  { icon:'💰', title:'Economic Nexus ($100K+ or 200 Transactions)', desc:'Most states require collection of sales tax once you exceed $100,000 in sales or 200 transactions in a state, even without a physical presence (post-Wayfair).' },
  { icon:'📦', title:'Inventory in a Fulfillment Center (FBA)', desc:'Amazon FBA and third-party warehouses storing your products in other states create nexus in those states — often unknown to sellers.' },
  { icon:'🤝', title:'Sales Representatives or Affiliates', desc:'Having sales agents, affiliates, or representatives in a state may create sufficient nexus for both sales and income tax obligations.' },
  { icon:'🌐', title:'Digital Products & SaaS', desc:'Many states now tax digital products, software subscriptions, and SaaS services. Economic nexus thresholds apply even to digital-only businesses.' },
];

const penalties = [
  { amount:'$330', name:'Per Missing W-2 (Small Business)', desc:'Up to $3,783,000 maximum per year for intentional disregard of W-2 filing requirements.' },
  { amount:'10%', name:'Trust Fund Penalty', desc:'The IRS can personally assess the Trust Fund Recovery Penalty against responsible parties who failed to deposit payroll taxes — piercing corporate liability.' },
  { amount:'25%+', name:'Payroll Tax Deposit Penalty', desc:'Late federal tax deposits are penalized on a tiered scale from 2% (1–5 days late) up to 15% (10+ days or after IRS notice).' },
  { amount:'Up to 50%', name:'State Sales Tax Fraud Penalty', desc:'States can assess penalties of 25–50% of unpaid tax for failure to collect and remit — plus interest and potential criminal charges in egregious cases.' },
  { amount:'$60–$310', name:'Per Late 1099-NEC', desc:'Failure-to-file penalties increase over time, from $60 per form (within 30 days) to $310 per form (after August 1) for small businesses.' },
  { amount:'Personal Liability', name:'Officer/Owner Liability', desc:'For payroll tax failures, the IRS can pierce the business structure and hold owners, officers, and bookkeepers personally responsible for unpaid taxes.' },
];

const faqs = [
  { q:'What is the difference between payroll taxes and income taxes?', a:'Income taxes are what employees owe on their wages — withheld by the employer. Payroll taxes include FICA (Social Security and Medicare), which are split between employer and employee. Employers are also responsible for FUTA and state unemployment taxes, which the employee doesn\'t pay.' },
  { q:'Do I have sales tax obligations in states where I don\'t have an office?', a:'Yes. After the 2018 Supreme Court Wayfair decision, most states require businesses to collect sales tax once they exceed $100,000 in annual sales or 200 transactions in that state — regardless of physical presence.' },
  { q:'What happens if I have back sales taxes I haven\'t collected?', a:'Many states offer Voluntary Disclosure Agreements (VDA) that let businesses come forward proactively to settle unpaid sales tax obligations — often with penalty waivers and limited lookback periods. We help negotiate these agreements.' },
  { q:'Are online and digital products taxable?', a:'It depends on the state and product type. SaaS, digital downloads, online courses, and streaming services are taxable in many states but exempt in others. We conduct a product-specific taxability analysis as part of our nexus review.' },
  { q:'How often do I need to file sales tax returns?', a:'Filing frequency depends on your annual sales volume in each state — typically monthly for higher-volume sellers, quarterly for moderate, and annually for low-volume. We track and file on your behalf regardless of frequency.' },
  { q:'Can I outsource payroll tax completely to you?', a:'Yes. We can take on complete responsibility for payroll tax deposits, quarterly 941 filings, year-end W-2s, 1099s, and all state registrations. We can work alongside your existing payroll provider or handle payroll setup from scratch.' },
];

const stateData = [
  {abbr:'CA',cls:'active',status:'Filing'},{abbr:'NY',cls:'active',status:'Filing'},{abbr:'TX',cls:'active',status:'Filing'},
  {abbr:'FL',cls:'watch',status:'Watch'},{abbr:'WA',cls:'watch',status:'Watch'},{abbr:'IL',cls:'watch',status:'Watch'},
  {abbr:'AZ',cls:'clear',status:'Clear'},{abbr:'GA',cls:'clear',status:'Clear'},{abbr:'CO',cls:'clear',status:'Clear'},
];

const PayrollSalesTax: React.FC<{ onBack?: () => void }> = ({ onBack }) => (
  <div className="pst-page">
    <style>{styles}</style>

    {/* Hero */}
    <section className="pst-hero">
      <div className="pst-hero-blob1" /><div className="pst-hero-blob2" />
      <div className="pst-hero-inner">
        <div>
          {onBack && (
            <button type="button" className="pst-back-btn" onClick={onBack}>
              <span aria-hidden="true">←</span> Back to Tax Services
            </button>
          )}
          <motion.div initial={{opacity:0,scale:0.9}} animate={{opacity:1,scale:1}} transition={{duration:0.5}}>
            <div className="pst-hero-badge"><span className="pst-badge-dot" />Full compliance across all states — managed for you</div>
          </motion.div>
          <motion.h1 initial={{opacity:0,y:30}} animate={{opacity:1,y:0}} transition={{duration:0.6,delay:0.1}}>
            Payroll & Sales Tax.<br /><span className="pst-gradient-text">Fully Handled.</span>
          </motion.h1>
          <motion.p initial={{opacity:0,y:20}} animate={{opacity:1,y:0}} transition={{duration:0.6,delay:0.2}}>
            Payroll tax penalties can pierce corporate liability and follow owners personally. Sales tax nexus has expanded to every state you sell in. We manage all of it — every form, every deadline, every state — so compliance is never your problem.
          </motion.p>
          <motion.div className="pst-btn-group" initial={{opacity:0,y:20}} animate={{opacity:1,y:0}} transition={{duration:0.5,delay:0.3}}>
            <button type="button" className="pst-btn-primary">Get Compliant Today →</button>
            <button type="button" className="pst-btn-secondary">Free Nexus Review</button>
          </motion.div>
        </div>
        <motion.div className="pst-hero-visual" initial={{opacity:0,x:40}} animate={{opacity:1,x:0}} transition={{duration:0.7,delay:0.2}}>
          <div className="pst-vis-header">
            <div className="pst-vis-title"><p>Compliance Dashboard</p><p>Horizon Retail Group</p></div>
            <div className="pst-vis-icon">📊</div>
          </div>
          {[
            {type:'done',icon:'✅',title:'Form 941 — Q2 2025','sub':'Federal payroll return filed Jun 28',badge:'Filed',badgeType:'done'},
            {type:'done',icon:'✅',title:'CA Sales Tax Return — June','sub':'$4,280 collected & remitted Jul 1',badge:'Remitted',badgeType:'done'},
            {type:'alert',icon:'⚡',title:'WA Economic Nexus Threshold','sub':'Just crossed $100K — registration required',badge:'Action Needed',badgeType:'alert'},
            {type:'upcoming',icon:'🗓️',title:'Form 941 — Q3 2025','sub':'Due October 31, 2025',badge:'Upcoming',badgeType:'upcoming'},
          ].map((item,i) => (
            <div className={`pst-filing-item ${item.type}`} key={i}>
              <span className="pst-filing-icon">{item.icon}</span>
              <div className="pst-filing-content">
                <div className="pst-filing-title">{item.title}</div>
                <div className="pst-filing-sub">{item.sub}</div>
              </div>
              <span className={`pst-filing-badge ${item.badgeType}`}>{item.badge}</span>
            </div>
          ))}
          <div className="pst-vis-summary">
            <span className="pst-vis-summary-dot" />
            <span className="pst-vis-summary-text">3 states active · 1 new registration in progress · 0 missed deadlines</span>
          </div>
        </motion.div>
      </div>
    </section>

    {/* Stats */}
    <div className="pst-stats">
      <div className="pst-stats-grid">
        {[
          {num:'50',label:'States Covered — All Jurisdictions',dark:false},
          {num:'0',label:'Missed Filing Deadlines on Record',dark:false},
          {num:'$0',label:'Penalties Assessed to Our Clients',dark:true},
          {num:'Full',label:'Payroll + Sales Tax Integration',dark:true},
        ].map((s,i) => (
          <motion.div className="pst-stat" key={i} {...stagger(i)}>
            <div className={`pst-stat-num${s.dark?' dark':''}`}>{s.num}</div>
            <div className="pst-stat-label">{s.label}</div>
          </motion.div>
        ))}
      </div>
    </div>

    {/* Split Services */}
    <section className="pst-section pst-split">
      <div className="pst-container">
        <motion.div className="pst-section-header" {...fadeIn}>
          <span className="pst-label">What's Covered</span>
          <h2>Complete Payroll Tax & Sales Tax Compliance</h2>
          <p>Two complex compliance areas, fully managed under one engagement. No gaps. No surprises.</p>
        </motion.div>
        <div className="pst-split-inner">
          <motion.div className="pst-half" {...stagger(0)}>
            <span className="pst-half-icon">💼</span>
            <h2>Payroll Tax Compliance</h2>
            <p>We handle every federal and state payroll tax obligation — from deposits to year-end filings — so you never face the devastating personal liability of a payroll tax failure.</p>
            <div className="pst-service-list">
              {payrollServices.map((s,i) => (
                <div className="pst-service-row" key={i}>
                  <div className="pst-service-dot blue">✓</div>
                  <span className="pst-service-row-text">{s}</span>
                </div>
              ))}
            </div>
          </motion.div>
          <motion.div className="pst-half" {...stagger(1)}>
            <span className="pst-half-icon">🌐</span>
            <h2>Sales Tax Compliance</h2>
            <p>Economic nexus now means most online and multi-state sellers have obligations they don't know about. We identify where you owe, register you, file your returns, and keep you protected.</p>
            <div className="pst-service-list">
              {salesTaxServices.map((s,i) => (
                <div className="pst-service-row" key={i}>
                  <div className="pst-service-dot green">✓</div>
                  <span className="pst-service-row-text">{s}</span>
                </div>
              ))}
            </div>
          </motion.div>
        </div>
      </div>
    </section>

    {/* Filing Calendar */}
    <section className="pst-section pst-calendar">
      <div className="pst-container">
        <div className="pst-cal-inner">
          <div className="pst-cal-glow1" /><div className="pst-cal-glow2" />
          <motion.div className="pst-cal-header" {...fadeIn}>
            <span className="pst-label">Filing Requirements</span>
            <h2>Every Form We Manage on Your Behalf</h2>
            <p>Payroll and sales tax compliance involves dozens of forms, deadlines, and jurisdictions. We track and file every one.</p>
          </motion.div>
          <div className="pst-filings-grid">
            {filingCards.map((fc,i) => (
              <motion.div className="pst-filing-card" key={i} {...stagger(i)}>
                <div className="pst-fc-form">{fc.form}</div>
                <div className="pst-fc-title">{fc.title}</div>
                <div className="pst-fc-freq">{fc.freq}</div>
                <div className="pst-fc-desc">{fc.desc}</div>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>

    {/* Nexus */}
    <section className="pst-section pst-nexus">
      <div className="pst-container">
        <div className="pst-nexus-inner">
          <motion.div className="pst-nexus-left" {...fadeIn}>
            <span className="pst-label">Sales Tax Nexus</span>
            <h2>You May Owe Sales Tax in More States Than You Think</h2>
            <p>The 2018 Wayfair decision eliminated the physical-presence requirement. Economic nexus means you can now owe sales tax in a state where you've never set foot — just by selling there.</p>
            <div className="pst-nexus-triggers">
              {nexusTriggers.map((t,i) => (
                <motion.div className="pst-nexus-trigger" key={i} {...stagger(i)}>
                  <span className="pst-nexus-icon">{t.icon}</span>
                  <div className="pst-nexus-text"><h4>{t.title}</h4><p>{t.desc}</p></div>
                </motion.div>
              ))}
            </div>
          </motion.div>
          <motion.div className="pst-nexus-visual" initial={{opacity:0,x:30}} whileInView={{opacity:1,x:0}} viewport={{once:true}} transition={{duration:0.6,delay:0.2}}>
            <div className="pst-nv-title">Example: Sales Tax Nexus Map</div>
            <div className="pst-state-grid">
              {stateData.map((s,i) => (
                <div className={`pst-state-chip ${s.cls}`} key={i}>
                  <div className={`pst-state-abbr ${s.cls}`}>{s.abbr}</div>
                  <div className={`pst-state-status ${s.cls}`}>{s.status}</div>
                </div>
              ))}
            </div>
            <div className="pst-nv-legend">
              {[{color:'#3b82f6',label:'Filing Required'},{color:'#ca8a04',label:'Approaching Threshold'},{color:'#e2e8f0',label:'No Nexus Yet'}].map((l,i) => (
                <div className="pst-nv-legend-item" key={i}>
                  <div className="pst-nv-dot" style={{background:l.color}} />
                  {l.label}
                </div>
              ))}
            </div>
          </motion.div>
        </div>
      </div>
    </section>

    {/* Penalties */}
    <section className="pst-section pst-penalties">
      <div className="pst-container">
        <motion.div className="pst-section-header" {...fadeIn}>
          <span className="pst-label">The Cost of Non-Compliance</span>
          <h2>Payroll & Sales Tax Penalties Are Severe — and Personal</h2>
          <p>Unlike income tax penalties, payroll tax failures can result in personal liability that follows business owners through bankruptcy. Don't leave this to chance.</p>
        </motion.div>
        <div className="pst-pen-grid">
          {penalties.map((p,i) => (
            <motion.div className="pst-pen-card" key={i} {...stagger(i)}>
              <div className="pst-pen-amount">{p.amount}</div>
              <div className="pst-pen-name">{p.name}</div>
              <div className="pst-pen-desc">{p.desc}</div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>

    {/* FAQ */}
    <section className="pst-section pst-faq">
      <div className="pst-container">
        <motion.div className="pst-section-header" {...fadeIn}>
          <span className="pst-label">Common Questions</span>
          <h2>Payroll & Sales Tax — Your Questions Answered</h2>
          <p>Don't see your question? Reach out — we offer a free nexus review and compliance consultation for new clients.</p>
        </motion.div>
        <div className="pst-faq-grid">
          {faqs.map((f,i) => (
            <motion.div className="pst-faq-item" key={i} {...stagger(i)}>
              <div className="pst-faq-q"><div className="pst-faq-q-icon">?</div>{f.q}</div>
              <div className="pst-faq-a">{f.a}</div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>

    {/* CTA */}
    <section className="pst-cta">
      <div className="pst-cta-inner">
        <div className="pst-cta-glow1" /><div className="pst-cta-glow2" />
        <motion.h2 {...fadeIn}>Get Fully Compliant — Before the State Finds You</motion.h2>
        <motion.p {...{...fadeIn,transition:{duration:0.55,delay:0.1}}}>
          Payroll tax deposits, multi-state sales tax filings, W-2s, 1099s — we manage every obligation for you, so compliance is never a worry and penalties are never an expense.
        </motion.p>
        <motion.div className="pst-cta-btns" {...{...fadeIn,transition:{duration:0.5,delay:0.2}}}>
          <button type="button" className="pst-cta-primary">Get Compliant Today →</button>
          <button type="button" className="pst-cta-secondary">Free Nexus Analysis</button>
        </motion.div>
        <motion.div className="pst-cta-badges" {...{...fadeIn,transition:{duration:0.5,delay:0.3}}}>
          {['All 50 states covered','Zero missed deadlines','Payroll + sales tax in one','Licensed CPAs only'].map((b,i) => (
            <div className="pst-cta-badge" key={i}><span className="pst-cta-badge-check">✓</span>{b}</div>
          ))}
        </motion.div>
      </div>
    </section>
  </div>
);

export default PayrollSalesTax;
